module.exports = require("react-pdf/dist/esm/pdf.worker.entry");